"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveCache = exports.PerspectiveCacheTable = exports.PerspectiveBindingGroup = void 0;
const pick_1 = __importDefault(require("lodash/pick"));
const zip_1 = __importDefault(require("lodash/zip"));
const difference_1 = __importDefault(require("lodash/difference"));
const debug_1 = __importDefault(require("debug"));
const json_stable_stringify_1 = __importDefault(require("json-stable-stringify"));
const perspectiveTools_1 = require("./perspectiveTools");
const dbg = (0, debug_1.default)('dbgate:PerspectiveCache');
class PerspectiveBindingGroup {
    constructor(table) {
        this.table = table;
        this.loadedRows = [];
    }
    matchRow(row) {
        return this.table.bindingColumns.every((column, index) => (0, perspectiveTools_1.perspectiveValueMatcher)(row[column], this.bindingValues[index]));
    }
}
exports.PerspectiveBindingGroup = PerspectiveBindingGroup;
class PerspectiveCacheTable {
    constructor(props, cache) {
        this.cache = cache;
        this.loadedRows = [];
        this.bindingGroups = {};
        this.allRowCount = null;
        this.schemaName = props.schemaName;
        this.pureName = props.pureName;
        this.bindingColumns = props.bindingColumns;
        this.dataColumns = props.dataColumns;
        this.loadedAll = false;
    }
    get loadedCount() {
        return this.loadedRows.length;
    }
    getRowsResult(props) {
        return {
            rows: this.loadedRows.slice(0, props.topCount),
            incomplete: props.topCount < this.loadedCount || !this.loadedAll,
        };
    }
    getBindingGroup(groupValues) {
        const key = (0, json_stable_stringify_1.default)(groupValues);
        return this.bindingGroups[key];
    }
    getUncachedBindingGroups(props) {
        const uncached = [];
        for (const group of props.bindingValues) {
            const key = (0, json_stable_stringify_1.default)(group);
            const item = this.bindingGroups[key];
            if (!item) {
                uncached.push(group);
            }
        }
        return uncached;
    }
    storeGroupSize(props, bindingValues, count) {
        const originalBindingValue = props.bindingValues.find(v => (0, zip_1.default)(v, bindingValues).every(([x, y]) => (0, perspectiveTools_1.perspectiveValueMatcher)(x, y)));
        // console.log('storeGroupSize NEW', bindingValues);
        // console.log('storeGroupSize ORIGINAL', originalBindingValue);
        if (originalBindingValue) {
            const key = (0, json_stable_stringify_1.default)(originalBindingValue);
            // console.log('SET SIZE', originalBindingValue, bindingValues, key, count);
            const group = new PerspectiveBindingGroup(this);
            group.bindingValues = bindingValues;
            group.groupSize = count;
            this.bindingGroups[key] = group;
        }
        else {
            dbg('Group not found', bindingValues);
        }
    }
}
exports.PerspectiveCacheTable = PerspectiveCacheTable;
class PerspectiveCache {
    constructor() {
        this.tables = {};
        this.dataPatterns = [];
    }
    getTableCache(props) {
        const tableKey = (0, json_stable_stringify_1.default)((0, pick_1.default)(props, [
            'schemaName',
            'pureName',
            'bindingColumns',
            'databaseConfig',
            'orderBy',
            'sqlCondition',
            'mongoCondition',
        ]));
        let res = this.tables[tableKey];
        if (res && (0, difference_1.default)(props.dataColumns, res.dataColumns).length > 0 && !res.allColumns) {
            dbg('Delete cache because incomplete columns', props.pureName, res.dataColumns);
            // we have incomplete cache
            delete this.tables[tableKey];
            res = null;
        }
        if (!res) {
            res = new PerspectiveCacheTable(props, this);
            this.tables[tableKey] = res;
            return res;
        }
        // cache could be used
        return res;
    }
    clear() {
        this.tables = {};
        this.dataPatterns = [];
    }
}
exports.PerspectiveCache = PerspectiveCache;
